import { FC } from 'react';
import { Box, Heading, Stack, StackDivider, Text } from '@chakra-ui/react';
import { CountUp } from 'use-count-up';
import { useStats } from 'hooks/query/useStats';

const defaultStats = {
  totalCrucibles: 0,
  totalLocked: 0,
  totalRewardsInProgram: 0,
  totalPrograms: 0
};

const Stats: FC = () => {
  const { data } = useStats();
  
  const { totalCrucibles, totalLocked, totalRewardsInProgram, totalPrograms } =
    data || defaultStats;

  return (
    <Stack
      py={[5, 5, 5, 10]}
      spacing={[3, 4, 4, 0]}
      borderRadius='xl'
      bg='whiteAlpha.100'
      backdropFilter='blur(25px)'
      direction={['column', 'column', 'column', 'row']}
      divider={<StackDivider borderColor='whiteAlpha.200' />}
    >
      <Box flexGrow={1} textAlign='center'>
        <Heading fontWeight='600'>
          <CountUp
            duration={0.5}
            isCounting={!!totalCrucibles}
            end={totalCrucibles}
            autoResetKey={totalCrucibles}
          />
        </Heading>
        <Text color='gray.300'>Total Crucibles</Text>
      </Box>
      <Box flexGrow={1} textAlign='center'>
        <Heading fontWeight='600'>
          <CountUp
            duration={0.5}
            isCounting={!!totalLocked}
            end={Math.round(totalLocked || 0)}
            autoResetKey={totalLocked}
            shouldUseToLocaleString={true}
            prefix='$'
          />
        </Heading>
        <Text color='gray.300'>Total locked</Text>
      </Box>
      <Box flexGrow={1} textAlign='center'>
        <Heading fontWeight='600'>
          <CountUp
            duration={0.5}
            isCounting={!!totalRewardsInProgram}
            end={Math.round(totalRewardsInProgram || 0)}
            autoResetKey={totalRewardsInProgram}
            shouldUseToLocaleString={true}
            prefix='$'
          />
        </Heading>
        <Text color='gray.300'>Total rewards in programs</Text>
      </Box>
      <Box flexGrow={1} textAlign='center'>
        <Heading fontWeight='600'>
          <CountUp
            duration={0.5}
            isCounting={!!totalPrograms}
            end={totalPrograms}
            autoResetKey={totalPrograms}
          />
        </Heading>
        <Text color='gray.300'>Total programs</Text>
      </Box>
    </Stack>
  );
};

export default Stats;
